import { AbstractMFAFactorModel, AbstractMFAFactorModelModelOptions } from './AbstractMFAFactorModel';

// TODO add logic if necessary
export class AuthenticatorMFAModel extends AbstractMFAFactorModel {
  name: string;
  /**
   * Contents of QR code containing the secret.
   * Only available when first created
   */
  factorURI: string | null;

  constructor(options: AbstractMFAFactorModelModelOptions) {
    super(options);
    this.factorURI = null;
    this.name = 'Authenticator';
  }
}
